export const FETCH_RATING_STORE = 'RatingStore/FETCH';
export const FETCH_RATING_STORE_SUCCESS = 'RatingStore/FETCH_SUCCESS';
export const FETCH_RATING_STORE_FAIL = 'RatingStore/FETCH_FAIL';

/* eslint-disable */
const RatingStoreReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case FETCH_RATING_STORE:
      return {
        ...state,
        [action.payload.vendorId]: {
          isLoading: true,
          isLoaded: false,
        },
      };
    case FETCH_RATING_STORE_SUCCESS:
      return {
        ...state,
        [action.payload.vendorId]: {
          isLoading: false,
          isLoaded: true,
          ...action.payload.data,
        },
      };
    case FETCH_RATING_STORE_FAIL:
      return {
        ...state,
        [action.payload.vendorId]: {
          isLoaded: false,
          isLoading: false,
          error: action.error,
        },
      };
    default:
      return { ...state };
  }
};

export default RatingStoreReducer;
